export const bugsnag = {
    apiKey: process.env.REACT_APP_BS_GIFTLY_CONSUMER_FRONT
};
